import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useAuth, isAdmin } from '@/lib/auth';
import { BrandLogo } from '@/lib/brand';

export default function PublicLayout() {
    const { user } = useAuth();
    return (
        <div className="min-h-screen bg-white flex flex-col" data-testid="public-layout">
            <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-md border-b border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
                    <Link to="/" data-testid="public-logo-link">
                        <BrandLogo />
                    </Link>
                    <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-700">
                        <Link to="/#categories" className="hover:text-brand-blue" data-testid="nav-categories">Categories</Link>
                        <Link to="/#arcade" className="hover:text-brand-blue" data-testid="nav-arcade">Arcade</Link>
                        <Link to="/#certifications" className="hover:text-brand-blue" data-testid="nav-certifications">Certifications</Link>
                        <Link to="/#about" className="hover:text-brand-blue" data-testid="nav-about">About</Link>
                    </nav>
                    <div className="flex items-center gap-2">
                        {user ? (
                            <Link
                                to={isAdmin(user) ? '/admin' : '/learn'}
                                className="px-4 py-2 rounded-xl bg-brand-blue text-white text-sm font-semibold hover:bg-brand-blueDark"
                                data-testid="cta-enter-app"
                            >
                                Enter Academy
                            </Link>
                        ) : (
                            <>
                                <Link
                                    to="/login"
                                    className="hidden sm:inline-flex px-3 py-2 text-sm font-semibold text-slate-700 hover:text-brand-blue"
                                    data-testid="cta-login"
                                >
                                    Login
                                </Link>
                                <Link
                                    to="/login?signup=1"
                                    className="px-4 py-2 rounded-xl bg-brand-blue text-white text-sm font-semibold hover:bg-brand-blueDark"
                                    data-testid="cta-signup"
                                >
                                    Get Started
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </header>
            <main className="flex-1"><Outlet /></main>
            <footer className="border-t border-slate-200 bg-slate-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <div>
                        <BrandLogo />
                        <p className="text-xs text-slate-500 mt-2 max-w-md">
                            Propulse Cables &amp; Wires Learning Academy — building India's most skilled electrical &amp; cables workforce.
                        </p>
                    </div>
                    <div className="text-xs text-slate-500">
                        © {new Date().getFullYear()} Propulse Cables &amp; Wires. All rights reserved. Powered by LearningHub.ai
                    </div>
                </div>
            </footer>
        </div>
    );
}
